(() => {
  if (window.p46OutdoorInitialized) return;
  window.p46OutdoorInitialized = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const roots = new Map();
  const videos = new Map();
  let pageHidden = false;
  const elements = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  const sync = (video, state) => {
    const shouldPlay = state.visible && !document.hidden && !pageHidden && (!reduced.matches || state.manualPlay) && !state.userPaused && video.isConnected;
    if (!shouldPlay) { video.pause(); return; }
    const source = video.querySelector('source');
    if (source?.dataset.src && !source.getAttribute('src')) { source.src = source.dataset.src; video.load(); }
    if (!video.paused || state.pending) return;
    state.pending = true;
    Promise.resolve(video.play()).catch(() => {}).finally(() => {
      state.pending = false;
      if (!state.visible || document.hidden || pageHidden || state.userPaused || !video.isConnected || (reduced.matches && !state.manualPlay)) video.pause();
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = videos.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio > 0;
      sync(entry.target, state);
    });
  }, {threshold: [0, .1]}) : null;
  function initVideos(root) {
    elements(root, '[data-family-film], .p46-collection-video__film').forEach(video => {
      if (videos.has(video)) return;
      const state = {visible: !observer, pending: false, userPaused: false, manualPlay: false, abort: new AbortController()};
      videos.set(video, state);
      video.muted = true;
      video.autoplay = false;
      const button = video.closest('.p46-collection-video')?.querySelector('.p46-collection-video__toggle');
      if (button) {
        const update = () => { button.textContent = video.paused ? '▶' : 'Ⅱ'; button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause); };
        video.addEventListener('play', update, {signal: state.abort.signal});
        video.addEventListener('pause', update, {signal: state.abort.signal});
        button.addEventListener('click', () => {
          state.userPaused = !video.paused || state.pending;
          state.manualPlay = !state.userPaused;
          sync(video, state);
        }, {signal: state.abort.signal});
        update();
      }
      if (observer) observer.observe(video); else sync(video, state);
    });
  }
  function init(root) {
    if (roots.has(root)) return;
    const abort = new AbortController();
    const opts = {signal: abort.signal};
    const cards = [...root.querySelectorAll('.p46-depth-card')];
    const cardObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || reduced.matches) entry.target.classList.remove('is-near');
        else if (entry.intersectionRatio >= .25) entry.target.classList.add('is-near');
      });
    }, {threshold: [0, .25]}) : null;
    cards.forEach(card => cardObserver?.observe(card));
    roots.set(root, {abort, cardObserver});
    const filter = root.querySelector('[data-category-filter]');
    if (filter) {
      const update = () => {
        let count = 0;
        root.querySelectorAll('[data-product-category]').forEach(item => { item.hidden = filter.value !== 'all' && item.dataset.productCategory !== filter.value; if (!item.hidden) count++; });
        const label = root.querySelector('[data-result-count]');
        if (label) label.textContent = count + ' ' + label.dataset.label;
        const empty = root.querySelector('[data-no-results]');
        if (empty) empty.hidden = count !== 0;
      };
      filter.addEventListener('change', update, opts); update();
    }
    root.querySelectorAll('[data-outdoor-video] button').forEach(button => button.addEventListener('click', () => {
      const holder = button.closest('[data-outdoor-video]');
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + holder.dataset.outdoorVideo + '?autoplay=1&rel=0';
      frame.title = button.getAttribute('aria-label') || 'YouTube';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true; frame.referrerPolicy = 'strict-origin-when-cross-origin';
      holder.replaceChildren(frame); frame.focus();
    }, opts));
  }
  const scan = root => { elements(root, '[data-outdoor]').forEach(init); initVideos(root); };
  const syncAll = () => videos.forEach((state, video) => sync(video, state));
  document.addEventListener('visibilitychange', syncAll);
  reduced.addEventListener('change', () => {
    videos.forEach(state => state.manualPlay = false);
    if (reduced.matches) document.querySelectorAll('.p46-depth-card.is-near').forEach(card => card.classList.remove('is-near'));
    syncAll();
  });
  window.addEventListener('pagehide', () => { pageHidden = true; syncAll(); });
  window.addEventListener('pageshow', () => { pageHidden = false; syncAll(); });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    roots.forEach((state, root) => { if (root === event.target || event.target.contains(root)) { state.abort.abort(); state.cardObserver?.disconnect(); roots.delete(root); } });
    videos.forEach((state, video) => { if (event.target.contains(video)) { state.abort.abort(); observer?.unobserve(video); video.pause(); videos.delete(video); } });
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const count = event.cartData?.item_count;
      if (!Number.isFinite(count)) return;
      document.querySelectorAll('.p46-cart').forEach(link => {
        const badge = link.querySelector('span');
        if (badge) badge.textContent = String(count);
        if (link.dataset.cartLabel) link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', String(count)));
      });
    });
  }
  scan(document);
})();
